import { DifficultyLevelType, getFirstDifficulty } from 'constants/difficulty';
import { DealData, emptyWinScore, Store } from 'game/store/gameStore';
import { getRandomItem } from './helpers/array';

export async function getSuit(id: string, forceKey?: DifficultyLevelType) {
    const dealGroup = await getDifficultyDeals(forceKey ? forceKey : Store.difficulty);

    try {
        if (dealGroup[id]) {
            const modules = import.meta.glob('./deals/*.js');
            const fetchDeal = async () => {
                const path = `./deals/${dealGroup[id]}.js`;
                const loader = modules[path];
                if (!loader) throw new Error('Module not found');
                const module = await loader();
                return module;
            };
            const module = await fetchDeal();
            const dealData: Record<string, string> = module.default as DealData;
            console.log({ difficulty: Store.difficulty, cards: mapCards(dealData[id]) });
            return { difficulty: Store.difficulty, cards: mapCards(dealData[id]) };
        } else {
            const firstDifficulty = getFirstDifficulty();
            const getRandomId = await getRandomDifficultyId(firstDifficulty);
            return getSuit(getRandomId, firstDifficulty);
        }
    } catch (error) {
        console.log(error);
        // localStorage.clear();
        // window.location.reload();
    }

    // return null;
}
export async function getSuitWinScore() {
    const dealGroup = await getDifficultyScore(Store.difficulty);
    let score = { ...emptyWinScore };
    if (!dealGroup) {
        Store.setGameWinScore(null);
        return;
    }
    if (dealGroup[Store.gameId]) {
        const parts = dealGroup[Store.gameId]?.split(',') || [];
        if (parts.length === 6) {
            score.minMoves = parseInt(parts[0]);
            score.maxMoves = parseInt(parts[1]);
            score.medianMoves = parseInt(parts[2]);
            score.minTime = parseInt(parts[3]);
            score.maxTime = parseInt(parts[4]);
            score.medianTime = parseInt(parts[5]);

            Store.setGameWinScore(score);
            return;
        }
    }

    Store.setGameWinScore(null);

    // return null;
}

export function getDifficultiesList() {
    const fileList: Record<DifficultyLevelType, string> = {
        [DifficultyLevelType.KLONDIKE_MEDIUM_3CARDS]: 'deal3c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_3CARDS]: 'deal3c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_3CARDS]: 'deal3c_expert',
    
        [DifficultyLevelType.KLONDIKE_EASY_1CARD]: 'deal1c_easy',
        [DifficultyLevelType.KLONDIKE_MEDIUM_1CARD]: 'deal1c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_1CARD]: 'deal1c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_1CARD]: 'deal1c_expert',
    
        [DifficultyLevelType.SPIDER_EASY_1SUIT]: 'spider1s_easy',
        [DifficultyLevelType.SPIDER_MEDIUM_1SUIT]: 'spider1s_medium',
        [DifficultyLevelType.SPIDER_HARD_1SUIT]: 'spider1s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_1SUIT]: 'spider1s_expert',
        [DifficultyLevelType.SPIDER_MEDIUM_2SUIT]: 'spider2s_medium',
        [DifficultyLevelType.SPIDER_EXPERT_2SUIT]: 'spider2s_expert',
        [DifficultyLevelType.SPIDER_HARD_2SUIT]: 'spider2s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_4SUIT]: 'spider4s_expert',
        [DifficultyLevelType.SPIDER_HARD_4SUIT]: 'spider4s_hard',
    
        [DifficultyLevelType.FREECELL_EASY]: 'free_easy',
        [DifficultyLevelType.FREECELL_MEDIUM]: 'free_medium',
        [DifficultyLevelType.FREECELL_HARD]: 'free_hard',
        [DifficultyLevelType.FREECELL_EXPERT]: 'free_expert',
    
        [DifficultyLevelType.PYRAMID_EASY]: 'pyramid_easy',
    };
    return fileList;
};



export async function getDifficultyDeals(targetKey: DifficultyLevelType) {
    try {
        const fileList = getDifficultiesList();
        const key = fileList[targetKey] ? targetKey : getFirstDifficulty();

        const fetchDealList = () => import(`./deals/${fileList[key]}.js`);
        const module = await fetchDealList();
        return module.default;
    } catch (error) {
        localStorage.clear();
        console.log('Error fetching difficulty deals:', error);
        // window.location.reload();
    }
}
export async function getDifficultyScore(targetKey: DifficultyLevelType) {
    try {
        const fileList = getDifficultiesList();
        const key = fileList[targetKey] ? targetKey : getFirstDifficulty();

        const fetchDealScore = () => import(`./deals/${fileList[key]}_score.js`);
        const module = await fetchDealScore();
        return module.default;
    } catch (error) {
        console.log('Error fetching difficulty score:', error);
        // window.location.reload();
    }
}
export async function getRandomDifficultyId(type: DifficultyLevelType) {
    const randomDeal = async (type: DifficultyLevelType) => {
        const deals = await getDifficultyDeals(type);

        if (!deals) {
            throw new Error(`getDifficultyDeals: Deal not found for type: ${type}, Reloaded page`);
        }

        const id = getRandomItem(Object.keys(deals));
        return id;
    };
    return await randomDeal(type);
}

const cardRank = ['empty index 0', 'A', '2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K'];

function mapCards(suitString: string) {
    const cards = [] as string[];
    const suitArray = suitString.split('*');
    suitArray.forEach((setString) => {
        const sets = setString.split(':');
        // do not use sets[0] - something for mobile app
        const value = cardRank[parseInt(sets[1])];
        const color = sets[2];
        // const open = sets[3];
        cards.push(value + color);
    });

    return cards;
}
